import { Children, ReactNode, isValidElement } from "react";
import { OptionsOrGroups } from "react-select";
import { GroupItem } from "../../Dropdown/GroupItem";
import { Group } from "../Group";
import { Option } from "../Option";
import { OptionItem } from "../OptionItem";
import { getOptions } from "./getOptions";

/**
 * Gets the items from the specified children.
 * @param children The children to get the items from.
 * @returns The array of items.
 */
export function getItems(children: ReactNode | undefined): OptionsOrGroups<OptionItem, GroupItem<OptionItem>> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;

      if (child.type === Option) {
        const { props } = child;
        const { children, label, value, type, inverted } = props;

        return { type: "option", label: children ?? label, value, tagType: type, tagInverted: inverted } as OptionItem;
      } else if (child.type === Group) {
        const { props } = child;
        const { label, children } = props;

        return { type: "group", label, options: getOptions(children) } as GroupItem<OptionItem>;
      }

      console.log("MultiSelectDropdown ignoring unsupported child component.");
      return null;
    })?.filter((option) => !!option) ?? []
  );
}
